import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CredentialsDtoRESET } from '@dto';
import { Credentials } from '@model';
import { GenericOldService } from './generic-old.service';

const usersResetEndpoint = 'users/reset-password';
const adminResetEndpoint = 'users/admin-reset-password';

@Injectable()
export class PasswordService {
  constructor(private resourceService: GenericOldService<Credentials | string>) {}

  resetPassword(credentials: Credentials): Observable<any> {
    if (!credentials.username || !credentials.oldPassword || !credentials.password) {
      return of(null);
    }
    return this.resourceService.post(usersResetEndpoint, credentials);
  }

  generatePassword(credentials: CredentialsDtoRESET): Observable<any> {
    if (!credentials) {
      return of(null);
    }
    return this.resourceService.post(adminResetEndpoint, credentials);
  }
}
